// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"387":"42217dc7","393":"eb9972fb","560":"2ff27635","633":"e8a13d7f","742":"d687e660","744":"a52199eb","787":"0f8d78ff","815":"eca42250","829":"45ede2c7"}[chunkId] + ".chunk.js";
};